import { queryOptions } from '@tanstack/react-query';

import { adminUserApi } from './admin-user.api';

export const adminUserQueryKeys = {
    me: ['admin-user', 'me'] as const,
};

export function adminUserOptions() {
    return queryOptions({
        queryKey: adminUserQueryKeys.me,
        queryFn: ({ signal }) => adminUserApi.get(signal),
        // A 401 is a normal unauthenticated answer here, not a transient failure — retrying
        // only delays the route guard's redirect.
        retry: false,
    });
}
